export const mutations = {
  toggleMainNav (state) {
    state.ui.mainNavOpen = !state.ui.mainNavOpen
  },
  gifsLoaded (state) {
    state.ui.gifsLoaded = true
  },
  closeMainNav (state) {
    state.ui.mainNavOpen = false
  },
  togglePageNav (state) {
    state.ui.pageNavOpen = !state.ui.pageNavOpen
  },
  closePageNav (state) {
    state.ui.pageNavOpen = false
  },
  openPageNav (state) {
    state.ui.pageNavOpen = true
  },
  togglePageScrolls: (state, payload) => {
    const $body = document.body || document.documentElement

    state.ui.disableScrolls = payload

    if ($body) {
      $body.setAttribute('data-scrolls', state.ui.disableScrolls ? 'hidden' : 'default')
    }
  },
  incrementFontSize (state) {
    state.ui.fontSize = Math.min(state.ui.fontSize + 1, state.ui.fontSizeMax)
  },
  decrementFontSize (state) {
    state.ui.fontSize = Math.max(state.ui.fontSize - 1, state.ui.fontSizeMin)
  },
  toggleContrast (state) {
    state.ui.contrast = !state.ui.contrast
  },
  goToNextCategory (state) {
    state.activeCategory = Math.min(state.categories.length - 1, state.activeCategory + 1)
  },
  goToPrevCategory (state) {
    state.activeCategory = Math.max(0, state.activeCategory - 1)
  },
  setBreakpoint (state, payload) {
    state.ui.breakpoint = payload
  },
  setWindowWidth (state, payload) {
    const screen = {
      'xs': 480,
      'sm': 768,
      'md': 1000,
      'lg': 1124,
      'xl': 1500
    }
    const screenLabel = Object.keys(screen).filter((s) => {
      return payload >= screen[s]
    })
    state.ui.windowWidth = (screenLabel[(screenLabel.length - 1)] ? screenLabel[(screenLabel.length - 1)] : 0)
  },
  getMainResponse (state, payload) {
    state.mainData = payload
  },
  getProduct (state, payload) {
    state.products = {
      products: state.products,
      [payload.id]: payload
    }
  },
  setDataLoaded (state, payload) {
    state.dataLoaded = payload
  },
  setCurrentProductId (state, payload) {
    state.currentProductId = payload
  },
  setNotLoggedIn (state, payload) {
    state.isLoggedIn = false
    state.authToken = null
    state.loggedUserId = null
  },
  setLoggedIn (state, payload) {
    if (payload.authKey) {
      state.isLoggedIn = true
      state.authToken = payload.authKey
      state.loggedUserId = payload.userId
    }
  },
  loginErrors (state, payload) {
    state.loginErrors = payload
  },
  isRegistered (state, payload) {
    state.isRegistered = payload
  },
  registerErrors (state, payload) {
    state.registerErrors = payload
    state.isRegistered = false
  },
  setFullscreen (state, payload) {
    state.isFullscreen = !state.isFullscreen
  },
  setIframeFullscreen (state, payload) {
    state.iframeFullscreen = !state.iframeFullscreen
  },
  setActiveFilters (state, payload) {
    state.activeFilters = payload
  },
  setActiveSearch (state, payload) {
    state.activeSearch = payload
  },
  setActiveListItem (state, payload) {
    state.activeListItem = payload
  },
  setNewsletterSignin (state, payload) {
    state.isNewsletterSignin = true
  },
  setNewsletterErrors (state, payload) {
    state.newsletterErrors = payload
  },
  clearNewsletterErrors (state, payload) {
    state.newsletterErrors = false
  },
  addToClipboard (state, payload) {
    if (state.clipboardItems.includes(payload)) {
      state.clipboardItems = state.clipboardItems.filter(item => item !== payload)
    } else {
      state.clipboardItems.push(payload)
    }
  }
}
